// Correspondance des types de documents entre le frontend et Supabase.
//
// Côté base (table `documents.type_document`) :
//   contrat | piece_identite | quittance | facture | recu | assurance | etat_des_lieux | autre | document_bien
//
// Côté interface :
//   contrat | piece-identite | document-bien | recu | facture | autre
//
// Chaque type d'interface possède un équivalent base exact. Les types base sans
// équivalent d'interface (quittance, assurance, etat_des_lieux) sont affichés
// comme « Autre » sans jamais être altérés en base.

const TYPE_TO_DB: Record<string, string> = {
  contrat: "contrat",
  "piece-identite": "piece_identite",
  "document-bien": "document_bien",
  recu: "recu",
  facture: "facture",
  autre: "autre",
};

const TYPE_FROM_DB: Record<string, string> = {
  contrat: "contrat",
  piece_identite: "piece-identite",
  document_bien: "document-bien",
  recu: "recu",
  facture: "facture",
  autre: "autre",
};

export function documentTypeToDb(value: string): string {
  return TYPE_TO_DB[value] ?? "autre";
}

export function documentTypeFromDb(value: string): string {
  return TYPE_FROM_DB[value] ?? "autre";
}